export default "__VITE_ASSET__mcr2Uzkp__"